<template>
    <tr v-if="collapseActive" class="dashboard__list_trainer_table_item_collapse_table">
        <td class="dashboard__list_trainer_table_item_collapse_table_wrapper" colspan="6">
            <table>
                <list-table-head :labels="['Date', 'Time', 'Trainers', sessionType === 'virtual' ? 'Platform' : 'Location', '']"/>
                <tbody>
                <template
                    v-for="(occurrenceItem, index) in occurrenceItems"
                >
                    <dashboard-list-trainer-table-item-collapse-table-item
                        :item="occurrenceItem"
                        :key="`dashboard-list-trainer-table-item-collapse-table-item-${index}`"
                    />
                </template>
                </tbody>
            </table>
        </td>
    </tr>
</template>

<script>
import ListTableHead from '@/components/default/shared/ListTableHead'
import DashboardListTrainerTableItemCollapseTableItem from '@/components/dashboard/list/trainer/DashboardListTrainerTableItemCollapseTableItem'
export default {
  name: 'dashboard-list-trainer-table-item-collapse-table',
  components: { DashboardListTrainerTableItemCollapseTableItem, ListTableHead },
  props: {
    item: {
      type: Object,
      required: true
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    occurrenceItems () {
      return this.item.occurrenceItems
    },
    sessionType () {
      return this.occurrenceItems.length ? this.occurrenceItems[0].sessionType : null
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/dashboard/list/_dashboardlisttableitemcollapse.scss";
</style>
